import React, {Component} from 'react';

import AgencyConnectionsExportContent from "./AgencyConnectionsExportContent";
import {withRouterParams} from "../../utils/withRouterParams";

class AgencyConnectionsExport extends Component {
    getOnBoardingStatus() {
        if (this.props.location.state === undefined || this.props.location.state === null) {
            return false
        } else {
            return this.props.location.state.showOnBoarding
        }
    }

    render() {
        return (
            <AgencyConnectionsExportContent agencyId={this.props.match.params.id}/>
        )
    }
}

export default withRouterParams(AgencyConnectionsExport);

